// ~/util/priceTitle/createTitle.js
import findMonthLocalization from '~/util/localization/findMonth'

// naslov za Srbiju
export const create = (title, week) => {
  const mn = String(week).split('.')
  const month = mn[1] ?? ''

  return (
    title +
    ' za mesec ' +
    findMonthLocalization.srMonth(month) +
    ' od ' +
    String(week).split('-').join(' ')
  )
}

// naslov za Hrvatsku
export const createHr = (title, week) => {
  const mn = String(week).split('.')
  const month = mn[1] ?? ''

  return (
    title +
    ' za mjesec ' +
    findMonthLocalization.hrMonth(month) +
    ' od ' +
    String(week).split('-').join(' ')
  )
}

// naslov za BiH / CG (srMonth)
export const createBih = (title, week) => {
  const mn = String(week).split('.')
  const month = mn[1] ?? ''

  return (
    title +
    ' za mjesec ' +
    findMonthLocalization.srMonth(month) +
    ' od ' +
    String(week).split('-').join(' ')
  )
}
